import React, { memo } from 'react'

import { Badge, Button, Text } from '../../../core'
import { Flex, Inline, Stack } from '../../../layout'
import { BackLink, StyledNavigationTitle } from './NavigationTitle.styles'

export type TitleProps = string | { value: string; link: string; linkTitle: string }
export interface NavigationTitleProps {
  actions?: React.ReactNode
  beta?: boolean
  description?: string | React.ReactNode
  onBackLinkClick?: () => void
  title: TitleProps
}

const NavigationTitle = ({
  actions,
  beta,
  description,
  onBackLinkClick,
  title,
}: NavigationTitleProps) => {
  if (typeof title === 'string')
    return (
      <Flex alignment="center">
        <Stack spacing="xxsmall">
          {beta ? (
            <Inline alignment="center" spacing="xsmall" noWrap>
              <Text variant="secondary" size="xlarge" heading data-e2e="title">
                {title}
              </Text>
              <Badge content="BETA" data-e2e="beta-label" variant="primary" position="right" />
            </Inline>
          ) : (
            <Text variant="secondary" size="xlarge" heading data-e2e="title">
              {title}
            </Text>
          )}
          {!!description && (
            <Text variant="secondary" size="medium" data-e2e="description">
              {description}
            </Text>
          )}
        </Stack>

        {actions}
      </Flex>
    )

  return (
    <Flex alignment="center">
      <StyledNavigationTitle spacing="xxsmall">
        <BackLink to={title.link} onClick={onBackLinkClick}>
          <Button variant="neutral" text icon="arrow-left">
            {title.linkTitle}
          </Button>
        </BackLink>

        {beta ? (
          <Inline alignment="center" spacing="xsmall" noWrap>
            <Text variant="secondary" size="xlarge" heading data-e2e="title">
              {title.value}
            </Text>
            <Badge content="BETA" data-e2e="beta-label" variant="primary" position="right" />
          </Inline>
        ) : (
          <Text variant="secondary" size="xlarge" heading data-e2e="title">
            {title.value}
          </Text>
        )}

        {!!description && typeof description === 'string' ? (
          <Text variant="secondary" size="medium" data-e2e="description">
            {description}
          </Text>
        ) : (
          description
        )}
      </StyledNavigationTitle>
      {actions}
    </Flex>
  )
}

export default memo(NavigationTitle)
